import classNames from 'classnames';
import { Button } from '../../UI/Button/Button';
import { configContext } from '../../../contexts/config/context';
import { genericMessages } from '../../../generic.i18n';
import React, { useContext } from 'react';
import { useIntl } from 'react-intl';
import { audioMessages } from './i18n';
import { styled } from '@mui/material/styles';
import { JSX } from '@emotion/react/jsx-runtime';

export const RecordAudioWarning = styled(
	({ className, ...props }: JSX.IntrinsicElements['div']) => {
		const { setIsRecordAudioApproved } = useContext(configContext);

		const intl = useIntl();
		const enable_microphone_warning = intl.formatMessage(
			audioMessages.enable_microphone_warning,
		);
		const yes = intl.formatMessage(genericMessages.yes);
		const no = intl.formatMessage(genericMessages.no);

		return (
			<div className={classNames('chat__record-audio', className)} {...props}>
				<span>{enable_microphone_warning}</span>
				<div className="buttons">
					<Button
						className="record-audio__yes"
						onClick={() => setIsRecordAudioApproved(true)}
					>
						{yes}
					</Button>
					<Button
						className="record-audio__no"
						onClick={() => setIsRecordAudioApproved(false)}
					>
						{no}
					</Button>
				</div>
			</div>
		);
	},
	{
		target: 'RecordAudioWarning-root',
		label: 'RecordAudioWarning',
	},
)({
	width: '100%',
	'& span': {
		fontSize: '1.3em',
	},
	'& .buttons': {
		display: 'flex',
		justifyContent: 'flex-end',
		marginTop: '0.5em',
		'& .button': {
			fontSize: '1.1em',
			'&:not(:last-child)': {
				marginRight: '0.5em',
			},
		},
	},
});
